import { classes } from 'html-classes';
import React from 'react';

import Icon from '~/components/Icon/Icon';

import styles from './Checkbox.module.scss';
import { ICON_SIZE_MAP, SIZE, SIZE_CLASS_MAP } from './constants';
import { CheckboxProps } from './interfaces';

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  size = SIZE.M,
  className,
  disabled = false,
  name,
  value,
  label,
  labelFirst = false,
  classes: classNames,
}) => {
  const iconSize = ICON_SIZE_MAP[size];
  const sizeClass = SIZE_CLASS_MAP[size];

  const { label: labelClassName } = classNames || {};

  return (
    <label
      className={classes([
        styles.checkbox,
        className,
        disabled && styles.disabled,
      ])}
    >
      <input
        type="checkbox"
        checked={checked}
        value={value}
        className={styles.input}
        onChange={onChange}
        disabled={disabled}
        name={name}
      />
      {label && labelFirst && (
        <span className={classes([styles.labelSub, labelClassName])}>
          {label}
        </span>
      )}
      <span className={classes([styles.mark, sizeClass])}>
        {checked && <Icon type="check-3.1" size={iconSize} />}
      </span>
      {label && !labelFirst && (
        <span className={classes([styles.label, labelClassName])}>{label}</span>
      )}
    </label>
  );
};

export default Checkbox;
